import { SharedModule } from '@/app/shared/shared.module';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { RegisterationSteps } from '@/app/auth/shared/auth-enums';
import { AuthService } from '@/app/auth/shared/services/auth.service';
import {
  BooleanResponseResult,
  CheckPhoneExistCommand,
  CountryViewModel,
  CreateOTPResultResponseResult,
  ErrorMessage,
  RegisterUserCompleteCommand,
  RequestPhoneOtpModel,
  UserProxy,
} from '@/app/proxy/proxies';
import { AppInitializerService } from '@/app/core/services/app-initializer.service';
import { extractBackendErrorMessage } from '@/app/auth/shared/auth-error.util';
@Component({
  selector: 'auth-register-phone',
  imports: [SharedModule],
  templateUrl: './phone-number.component.html',
  styleUrl: './phone-number.component.less',
  providers: [UserProxy],
})
export class PhoneNumberComponent implements OnInit {
  @Output() steperChange = new EventEmitter<RegisterationSteps>();

  registerModal: RegisterUserCompleteCommand = new RegisterUserCompleteCommand();
  phoneNumber: number;
  selectedCountry: CountryViewModel = new CountryViewModel();
  countries: CountryViewModel[] = [];

  somethingWentWrong: boolean = false;
  errorMessage: string = '';
  submitting: boolean = false;

  constructor(
    private _authService: AuthService,
    private _userProxy: UserProxy,
    private _applicationService: AppInitializerService
  ) {
    this.countries = this._applicationService.appStartupData.countries;
  }

  ngOnInit(): void {
    const registerModal = this._authService.getRegisterModal();
    if (registerModal !== undefined) {
      this.registerModal = registerModal;
    } else {
      this.steperChange.emit(RegisterationSteps.EMAIL);
    }
  }
  backButton() {
    this.steperChange.emit(RegisterationSteps.PASSWORD);
  }

  continuePhoneStep() {
    if (this.submitting) {
      return;
    }

    // The country dropdown can still be empty when the user hits continue.
    if (!this.phoneNumber || !this.selectedCountry?.phoneCode) {
      return;
    }

    let castedPhoneNumber = this.phoneNumber.toString().replace(/-/g, '');
    this.registerModal.phone = castedPhoneNumber;
    this.registerModal.phoneCode = this.selectedCountry.phoneCode.replace(/\+/g, '');

    if (castedPhoneNumber && castedPhoneNumber.length >= 6 && !this.somethingWentWrong) {
      this.submitting = true;
      let input = new CheckPhoneExistCommand();
      input.phone = this.registerModal.phone;
      input.phoneCode = this.registerModal.phoneCode;
      this._userProxy.user_CheckPhoneExist(input).subscribe({
        next: (res: BooleanResponseResult) => {
          if (!res.result) {
            this.somethingWentWrong = false;
            this.errorMessage = '';
            this.requestPhoneOtp();
          } else {
            this.somethingWentWrong = true;
            this.errorMessage = 'doktar_app.register.phone_is_exist_error';
            this.submitting = false;
          }
        },
        error: () => {
          this.submitting = false;
        },
      });
    }
  }

  /**
   * Request the registration phone OTP. Countries where the backend disabled phone
   * verification answer with otpRequired false, so the OTP step is skipped and the
   * registration is submitted without a phone code.
   */
  private requestPhoneOtp() {
    this._userProxy
      .user_RequestPhoneOtp(
        new RequestPhoneOtpModel({
          phoneCode: this.registerModal.phoneCode,
          phone: this.registerModal.phone,
        })
      )
      .subscribe({
        next: (res: CreateOTPResultResponseResult) => {
          if (!res.isSuccess || !res.result) {
            this.handlePhoneOtpRequestFailure(res.errors);
            return;
          }

          const otpRequired = res.result.otpRequired;
          this.registerModal.phoneOtp = undefined;
          this._authService.setRegisterModal(this.registerModal);

          this.steperChange.emit(otpRequired ? RegisterationSteps.VERIFY_PHONE_OTP : RegisterationSteps.ABOUT);
          this.submitting = false;
        },
        error: () => this.handlePhoneOtpRequestFailure(),
      });
  }

  private handlePhoneOtpRequestFailure(errors?: ErrorMessage[]) {
    this.submitting = false;
    this.somethingWentWrong = true;
    this.errorMessage = extractBackendErrorMessage(errors);
  }

  onPhoneNumberChange(_event: any) {
    if (this.somethingWentWrong) {
      this.somethingWentWrong = false;
      this.errorMessage = '';
    }
  }

  isValidPhoneNumber(phoneNumber: string): boolean {
    return phoneNumber.length >= 6;
  }

  skipAndGoToNextStep() {
    this.registerModal.phone = undefined;
    this.registerModal.phoneCode = undefined;
    this.registerModal.phoneOtp = undefined;
    this._authService.setRegisterModal(this.registerModal);
    this.steperChange.emit(RegisterationSteps.ABOUT);
  }
  
  goToNextStep() {
    this.steperChange.emit(RegisterationSteps.ABOUT);
  }
}
